import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Avatar from 'components/avatar';
import UserAvatar from 'components/user-avatar';
import Tooltip from 'components/tooltip';

const UserFaces = ({ showStatus, className, size, border, users, subtitles, subtitleIcon, additionals, tooltip, tooltipPlacement, tooltipContent, maxUsersCount, onClick, onSubtitleClick, onPermissionChange }) => {
    const validUsers = useMemo(() => users.filter(Boolean), [users]);
    const exceedsLimit = useMemo(() => validUsers.length > maxUsersCount, [validUsers, maxUsersCount]);
    const usersToRender = useMemo(() => {
        let result = [];

        if (exceedsLimit) {
            result = validUsers.slice(0, maxUsersCount);
        } else {
            result = validUsers;
        }

        return result.map(u => u.id || u);
    }, [exceedsLimit, validUsers, maxUsersCount]);

    if (!users) {
        return null;
    }

    return (
        <div className={'user-faces user-faces-' + size + ' ' + className}>
            <React.Fragment>
                {
                    usersToRender.map((userId, index) => (
                        <UserAvatar
                            key={userId || index}
                            id={userId}
                            size={size}
                            border={border}
                            onPermissionChange={onPermissionChange}
                            tooltip={tooltip}
                            tooltipPlacement={tooltipPlacement}
                            tooltipContent={tooltipContent}
                            showStatus={showStatus}
                            subtitle={subtitles && Array.isArray(subtitles) ? (subtitles.find(user => user.id === userId) || {}).subtitle : subtitles}
                            additional={additionals && Array.isArray(additionals) ? (additionals.find(user => user.id === userId) || {}).additional : additionals}
                            subtitleIcon={subtitleIcon}
                            onSubtitleClick={onSubtitleClick}
                            onClick={onClick}
                        />
                    ))
                }

                {
                    exceedsLimit ? (
                        <Avatar
                            key="remaining"
                            text={`+${validUsers.length - maxUsersCount}`}
                            size={size}
                            border={border}
                            empty={true}
                            users={validUsers.slice(maxUsersCount)}
                            subtitles={subtitles}
                            onSubtitleClick={onSubtitleClick}
                            onClick={onClick}
                        />
                    ) : null
                }
            </React.Fragment>
        </div>
    );

}

UserFaces.propTypes = {
    showStatus: PropTypes.bool,
    className: PropTypes.string,
    size: PropTypes.string,
    border: PropTypes.bool,
    users: PropTypes.array,
    subtitles: PropTypes.any,
    subtitleIcon: PropTypes.any,
    additionals: PropTypes.any,
    tooltip: PropTypes.bool,
    tooltipPlacement: PropTypes.string,
    tooltipContent: PropTypes.any,
    maxUsersCount: PropTypes.number,
    onClick: PropTypes.func,
    onSubtitleClick: PropTypes.func,
    onPermissionChange: PropTypes.func
};

UserFaces.defaultProps = {
    maxUsersCount: 8,
    className: '',
    tooltip: true
};

export default UserFaces;
